<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  modelValue: { type: String, default: null },
  fonts: { type: Object, default: () => ({ safe: [], google: [] }) },
  label: { type: String, default: '' },
});
const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();
</script>

<template>
  <label class="flex flex-col gap-1.5">
    <span class="text-xs font-medium text-n-slate-11">{{ label }}</span>
    <select
      class="rounded-lg border border-n-weak bg-n-solid-1 px-2 py-1.5 text-sm"
      :value="modelValue || ''"
      @change="emit('update:modelValue', $event.target.value || null)"
    >
      <option value="">
        {{ t('EMAIL_TEMPLATES.EDITOR.PROPS.FONT_DEFAULT') }}
      </option>
      <optgroup :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.FONT_SAFE')">
        <option
          v-for="f in fonts.safe"
          :key="f"
          :value="f"
          :style="{ fontFamily: f }"
        >
          {{ f }}
        </option>
      </optgroup>
      <optgroup :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.FONT_GOOGLE')">
        <option v-for="f in fonts.google" :key="f" :value="f">{{ f }}</option>
      </optgroup>
    </select>
  </label>
</template>
